import { Component, OnInit } from '@angular/core';
import { DecksService, DecksWithTotalCount } from '../decks.service';
import { EditableDataField } from '../../common/filter/editable-data-field';
import { Pagination, Query } from '@deckplan.io/common';
import { Utils } from '../common/utils';
import { PageEvent } from '@angular/material/paginator';
import { FormControl } from '@angular/forms';
import { AuthService } from '../../auth/auth.service';

@Component({
    selector: 'app-public-decks',
    templateUrl: './public-decks.component.html',
    styleUrls: ['./public-decks.component.scss']
})
export class PublicDecksComponent implements OnInit {

    public decksWithTotalCount: DecksWithTotalCount;

    public isLoadingResults = true;

    public asc = true;

    // eslint-disable-next-line no-magic-numbers
    public pageSizeOptions = [5, 10, 50, 100];
    public defaultPageIndex = 0;
    // eslint-disable-next-line no-magic-numbers
    public defaultPageSize = 10;

    public searchColumns: EditableDataField[] = [
        {dataType: 'string', field: 'name', title: 'Deck Name', isInput: false},
        {dataType: 'string', field: 'format', title: 'Deck Format', isInput: false},
        {dataType: 'string', field: 'alias', title: 'Deck Owner', objectType: 'user', isInput: false},
        {dataType: 'color', field: 'colorIdentity', title: 'Deck Color', objectType: 'card', isInput: false},
        {dataType: 'string', field: 'name', title: 'Card Name', objectType: 'card', isInput: false},
        {dataType: 'string', field: 'setName', title: 'Card Set', objectType: 'card', isInput: false},
        {dataType: 'color', field: 'specialData', title: 'Commander Color', isInput: false}
    ] as any;

    public sortFieldCtl = new FormControl({field: 'name', title: 'Deck Name', dataType: 'string', isInput: false});

    private query: Query;
    private readonly page: Pagination = {
        page: {pageIndex: 0, pageSize: 10},
        sort: {active: 'deck.name', direction: 'asc'}
    };

    constructor(private readonly decksService: DecksService, public readonly authService: AuthService) { }

    public ngOnInit() {
        this.loadDecks();
        this.sortFieldCtl.valueChanges.subscribe(field => {
            const active = field.objectType ? `${field.objectType}.${field.field}` : `deck.${field.field}`;
            this.sortByField(active);
        });
    }

    public newQuery(query: Query) {
        this.query = Utils.AddInventoryCardFields(query);
        this.loadDecks();
    }

    public newPage(pageEvent: PageEvent) {
        this.page.page = {pageIndex: pageEvent.pageIndex, pageSize: pageEvent.pageSize};
        this.loadDecks();
    }

    private loadDecks() {
        this.decksService.getPublic(this.query, this.page).subscribe(decksWithTotalCount => {
            this.decksWithTotalCount = decksWithTotalCount;
            this.isLoadingResults = false;
        });
    }

    public sortByField(field: string) {
        this.page.sort.active = field;
        this.loadDecks();
    }

    public toggleDirection() {
        this.asc = !this.asc;
        this.page.sort.direction = this.asc ? 'asc' : 'desc';
        this.loadDecks();
    }

}
